import { useLanguage } from "@/context/LanguageContext";

const ContactSubmitButton = ({ isSubmitting }) => {
  const { copy } = useLanguage();
  const label = isSubmitting ? copy.contact.formSending : copy.contact.formSubmit;

  return (
    <button
      type="submit"
      className="primary-button"
      data-testid="contact-submit"
      disabled={isSubmitting}
    >
      {label}
    </button>
  );
};

export default ContactSubmitButton;
